module.exports = __webpack_public_path__ + "asset/img/erweima.5b6891f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweima.png
// module id = lEKJ
// module chunks = 1